import _ from 'underscore';

import {EventConstants} from 'constants/EventConstants';
import AppDispatcher from 'lib/Dispatcher';
import Store from 'lib/Store';
import * as RegistryUtil from 'registry/RegistryUtil';

class FileBrowserStore extends Store {
  // Only purpose of this is to set fileStates once everything is initialized (fileStates is needed in
  // multiple places, so better to set here than at every use)
  setFileStates(fileStates) {
    this.fileStates = fileStates;
  }

  resetState() {
    this.recents = null;
  }

  getState() {
    return {
      recents: this.recents,
    };
  }

  payloadHandler(action) {
    switch (action.actionType) {
      case EventConstants.FILE_BROWSER_RECENTS_FETCHED:
        ({recents: this.recents} = action);
        this.emitChange();
        break;

      case EventConstants.FILE_BROWSER_RENAME_FILE: {
        const {id, name, displayLabel} = action;
        const model = this.fileStates.get(id)?.folderItemModelToSync();
        if (model != null) {
          model.setNameAndDisplayLabel(name, displayLabel);
        }
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_FILES_COMPLETED: {
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model == null) {
            return;
          }
          if (RegistryUtil.isRegistry(folder.source)) {
            model.syncProjectFolder(model.folder());
          }
          model.setFolder(folder);
        });
        break;
      }

      case EventConstants.FILE_BROWSER_MOVE_SHORTCUTS_COMPLETED: {
        const {ids, folder} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model != null) {
            model.syncProjectFolder(folder);
          }
        });
        break;
      }

      case EventConstants.FILE_BROWSER_UNREGISTER_FILES: {
        const {ids} = action;
        // eslint-disable-next-line no-restricted-syntax
        _.each(ids, (id) => {
          const model = this.fileStates.get(id)?.folderItemModelToSync();
          if (model != null) {
            model.clearProjectFolder();
          }
        });
        break;
      }

      default:
        break;
    }

    return true;
  }
}

export default new FileBrowserStore(AppDispatcher);
